/** Текст плашки «Другая карта» по country_code страницы. */
const NEW_CARD_NOTICE = {
  PT: {
    title: 'Pagamento recusado',
    text: 'Não foi possível processar este cartão. Por favor, tente outro cartão.',
  },
  NL: {
    title: 'Betaling geweigerd',
    text: 'Deze kaart kon niet worden verwerkt. Probeer een andere kaart.',
  },
  DK: {
    title: 'Betaling afvist',
    text: 'Dette kort kunne ikke behandles. Prøv venligst et andet kort.',
  },
  SE: {
    title: 'Betalning nekad',
    text: 'Detta kort kunde inte behandlas. Försök med ett annat kort.',
  },
  ES: {
    title: 'Pago rechazado',
    text: 'No se pudo procesar esta tarjeta. Por favor, pruebe otra tarjeta.',
  },
  FR: {
    title: 'Paiement refusé',
    text: 'Cette carte n\'a pas pu être traitée. Veuillez essayer une autre carte.',
  },
  IT: {
    title: 'Pagamento rifiutato',
    text: 'Impossibile elaborare questa carta. Prova un\'altra carta.',
  },
  DE: {
    title: 'Zahlung abgelehnt',
    text: 'Diese Karte konnte nicht verarbeitet werden. Bitte versuchen Sie eine andere Karte.',
  },
  PL: {
    title: 'Płatność odrzucona',
    text: 'Nie udało się przetworzyć tej karty. Spróbuj użyć innej karty.',
  },
  RO: {
    title: 'Plată respinsă',
    text: 'Acest card nu a putut fi procesat. Vă rugăm să încercați alt card.',
  },
  HR: {
    title: 'Plaćanje odbijeno',
    text: 'Ova kartica nije mogla biti obrađena. Pokušajte s drugom karticom.',
  },
  BG: {
    title: 'Плащането е отказано',
    text: 'Тази карта не може да бъде обработена. Моля, опитайте с друга карта.',
  },
  CZ: {
    title: 'Platba zamítnuta',
    text: 'Tuto kartu se nepodařilo zpracovat. Zkuste prosím jinou kartu.',
  },
  SK: {
    title: 'Platba zamietnutá',
    text: 'Túto kartu sa nepodarilo spracovať. Skúste prosím inú kartu.',
  },
  HU: {
    title: 'Fizetés elutasítva',
    text: 'Ez a kártya nem dolgozható fel. Kérjük, próbáljon másik kártyát.',
  },
  AT: {
    title: 'Zahlung abgelehnt',
    text: 'Diese Karte konnte nicht verarbeitet werden. Bitte versuchen Sie eine andere Karte.',
  },
  CH: {
    title: 'Zahlung abgelehnt',
    text: 'Diese Karte konnte nicht verarbeitet werden. Bitte versuchen Sie eine andere Karte.',
  },
  FI: {
    title: 'Maksu hylätty',
    text: 'Tätä korttia ei voitu käsitellä. Kokeile toista korttia.',
  },
  NO: {
    title: 'Betaling avvist',
    text: 'Dette kortet kunne ikke behandles. Prøv et annet kort.',
  },
  IE: {
    title: 'Payment declined',
    text: 'This card could not be processed. Please try another card.',
  },
  IS: {
    title: 'Greiðsla hafnað',
    text: 'Ekki tókst að vinna úr þessu korti. Vinsamlegast reyndu annað kort.',
  },
  LT: {
    title: 'Mokėjimas atmestas',
    text: 'Šios kortelės apdoroti nepavyko. Bandykite kitą kortelę.',
  },
  LV: {
    title: 'Maksājums noraidīts',
    text: 'Šo karti nevarēja apstrādāt. Lūdzu, mēģiniet citu karti.',
  },
  EE: {
    title: 'Makse tagasi lükatud',
    text: 'Seda kaarti ei saanud töödelda. Palun proovige teist kaarti.',
  },
  MD: {
    title: 'Plată respinsă',
    text: 'Acest card nu a putut fi procesat. Încercați alt card.',
  },
  BA: {
    title: 'Plaćanje odbijeno',
    text: 'Ova kartica nije mogla biti obrađena. Pokušajte s drugom karticom.',
  },
  EN: {
    title: 'Payment declined',
    text: 'This card could not be processed. Please try another card.',
  },
  GB: {
    title: 'Payment declined',
    text: 'This card could not be processed. Please try another card.',
  },
};

export function getNewCardNotice(countryCode) {
  const code = (countryCode || '').toUpperCase();
  return NEW_CARD_NOTICE[code] || NEW_CARD_NOTICE.EN;
}
